<ng-container [formGroup]="form">
  <div class="form-group" [hidden]="form?.disabled">
    <!-- GENERAL PROVISIONS -->
    <h3>{{ labels.creditProvision.generalProvisions }}</h3>
    <div class="form-row">
      <div
        *ngIf="
          form.get(
            'creditPeriodStartDaysBeforeTradeDate'
          ) as creditPeriodStartDaysBeforeTradeDate
        "
        class="form-group col-lg-2"
        [hidden]="creditPeriodStartDaysBeforeTradeDate.disabled"
      >
        <app-dc-select
          [label]="labels.creditProvision.creditPeriodStartDaysBeforeTradeDate"
          [id]="'creditPeriodStartDaysBeforeTradeDate'"
          formControlName="creditPeriodStartDaysBeforeTradeDate"
          container="body"
          [items]="creditPeriodStartDaysItems"
          [FreeText]="true"
          [helpText]="'Specified as a number of days before the Trade Date.'"
          [clearSelection]="true"
          [closeOnSelect]="true"
          [searchable]="true"
        ></app-dc-select>
      </div>
      <div
        *ngIf="form.get('creditPeriodEndDate') as creditPeriodEndDate"
        class="form-group col-lg-2"
        [hidden]="creditPeriodEndDate.disabled"
      >
        <app-dc-date-input
          [label]="labels.creditProvision.creditPeriodEndDate"
          [id]="'creditPeriodEndDate'"
          placeholder=""
          formControlName="creditPeriodEndDate"
          container="body"
        ></app-dc-date-input>
      </div>
      <div
        *ngIf="form.get('lossAtMaturity') as lossAtMaturity"
        class="form-group col-lg-2"
        [hidden]="lossAtMaturity.disabled"
      >
        <app-dc-select
          [labelId]="'lossAtMaturity'"
          [label]="labels.creditProvision.lossAtMaturity"
          [items]="lossAtMaturityItems"
          closeOnSelect="true"
          formControlName="lossAtMaturity"
        ></app-dc-select>
      </div>
      <div
        *ngIf="form.get('accruedInterest') as accruedInterest"
        class="form-group col-lg-2"
        [hidden]="accruedInterest.disabled"
      >
        <app-dc-select
          [labelId]="'accruedInterest'"
          [label]="labels.creditProvision.accruedInterest"
          [items]="accruedInterestItems"
          closeOnSelect="true"
          formControlName="accruedInterest"
          [clearSelection]="true"
        ></app-dc-select>
      </div>
    </div>

    <div class="form-row">
      <div
        *ngIf="
          form.get(
            'cashSettlementQuotationMethod'
          ) as cashSettlementQuotationMethod
        "
        class="form-group col-lg-2"
        [hidden]="cashSettlementQuotationMethod.disabled"
      >
        <app-dc-select
          [labelId]="'cashSettlementQuotationMethod'"
          [label]="labels.creditProvision.cashSettlementQuotationMethod"
          [items]="cashSettlementQuotationItems"
          closeOnSelect="true"
          formControlName="cashSettlementQuotationMethod"
          [clearSelection]="true"
        ></app-dc-select>
      </div>
      <div
        *ngIf="
          form.get(
            'cashSettlementValuationMethod'
          ) as cashSettlementValuationMethod
        "
        class="form-group col-lg-2"
        [hidden]="cashSettlementValuationMethod.disabled"
      >
        <app-dc-select
          [labelId]="'cashSettlementValuationMethod'"
          [label]="labels.creditProvision.cashSettlementValuationMethod"
          [items]="cashSettlementValuationItems"
          closeOnSelect="true"
          formControlName="cashSettlementValuationMethod"
          [clearSelection]="true"
        ></app-dc-select>
      </div>
      <div
        *ngIf="form.get('minimumQuotation') as minimumQuotation"
        class="form-group col-lg-2"
        [hidden]="minimumQuotation.disabled"
      >
        <app-dc-input-number-percent-indicative-final
          [label]="labels.creditProvision.minimumQuotation"
          [id]="'minimumQuotation'"
          formControlName="minimumQuotation"
          defaultUnit="pct"
        ></app-dc-input-number-percent-indicative-final>
      </div>
    </div>

    <div class="form-row">
      <div
        *ngIf="form.get('passThroughSecurities') as passThroughSecurities"
        class="form-group col-lg-2"
        [hidden]="passThroughSecurities.disabled"
      >
        <app-dc-select
          [labelId]="'passThroughSecurities'"
          [label]="labels.creditProvision.passThroughSecurities"
          [items]="applicableItems"
          closeOnSelect="true"
          formControlName="passThroughSecurities"
          [clearSelection]="true"
        ></app-dc-select>
      </div>
      <div
        *ngIf="form.get('fxPriceSource') as fxPriceSource"
        class="form-group col-lg-2"
        [hidden]="fxPriceSource.disabled"
      >
        <app-dc-input
          [label]="labels.creditProvision.fxPriceSource"
          [id]="'fxPriceSource'"
          type="text"
          formControlName="fxPriceSource"
          [readonly]="fxPriceSource.readOnly"
        ></app-dc-input>
      </div>
      <div
        *ngIf="form.get('fixingRateTime') as fixingRateTime"
        class="form-group col-lg-2"
        [hidden]="fixingRateTime.disabled"
      >
        <app-dc-input
          [label]="labels.creditProvision.fixingRateTime"
          [id]="'fixingRateTime'"
          type="text"
          formControlName="fixingRateTime"
          [readonly]="fixingRateTime.readOnly"
        ></app-dc-input>
      </div>
      <div
        *ngIf="
          form.get(
            'additionalCreditBusinessCentre'
          ) as additionalCreditBusinessCentre
        "
        class="form-group col-lg-2"
        [hidden]="additionalCreditBusinessCentre.disabled"
      >
        <app-dc-toggle
          [labelId]="'additionalCreditBusinessCentre'"
          [label]="labels.creditProvision.additionalCreditBusinessCentre"
          formControlName="additionalCreditBusinessCentre"
        ></app-dc-toggle>
      </div>
      <div
        *ngIf="
          form.get(
            'additionalCreditBusinessCentreDetails'
          ) as additionalCreditBusinessCentreDetails
        "
        class="form-group col-lg-4"
        [hidden]="additionalCreditBusinessCentreDetails.disabled"
      >
        <app-dc-input
          [label]="labels.creditProvision.additionalCreditBusinessCentreDetails"
          [id]="'additionalCreditBusinessCentreDetails'"
          type="text"
          formControlName="additionalCreditBusinessCentreDetails"
        ></app-dc-input>
      </div>
    </div>

    <div class="form-row">
      <div
        *ngIf="
          form.get(
            'creditContingentCallOptionSecurities'
          ) as creditContingentCallOptionSecurities
        "
        class="form-group col-lg-4"
        [hidden]="creditContingentCallOptionSecurities.disabled"
      >
        <app-dc-toggle
          [labelId]="'creditContingentCallOptionSecurities'"
          [label]="labels.creditProvision.creditContingentCallOptionSecurities"
          formControlName="creditContingentCallOptionSecurities"
        ></app-dc-toggle>
      </div>
      <div
        *ngIf="
          form.get(
            'creditEventAccruedCouponSecurities'
          ) as creditEventAccruedCouponSecurities
        "
        class="form-group col-lg-4"
        [hidden]="creditEventAccruedCouponSecurities.disabled"
      >
        <app-dc-toggle
          labelId="creditEventAccruedCouponSecurities"
          [label]="labels.creditProvision.creditEventAccruedCouponSecurities"
          formControlName="creditEventAccruedCouponSecurities"
        ></app-dc-toggle>
      </div>
      <div
        *ngIf="form.get('dcDeterminations') as dcDeterminations"
        class="form-group col-lg-4"
        [hidden]="dcDeterminations.disabled"
      >
        <app-dc-toggle
          [labelId]="'dcDeterminations'"
          [label]="labels.creditProvision.dcDeterminations"
          formControlName="dcDeterminations"
        ></app-dc-toggle>
      </div>
    </div>

    <div class="form-row">
      <div
        *ngIf="
          form.get(
            'detailsRelatingToInstalmentNotes'
          ) as detailsRelatingToInstalmentNotes
        "
        class="form-group col-lg-4"
        [hidden]="detailsRelatingToInstalmentNotes.disabled"
      >
        <app-dc-toggle
          [labelId]="'detailsRelatingToInstalmentNotes'"
          [label]="labels.creditProvision.detailsRelatingToInstalmentNotes"
          formControlName="detailsRelatingToInstalmentNotes"
        ></app-dc-toggle>
      </div>
      <div
        *ngIf="form.get('extensionPeriodInterest') as extensionPeriodInterest"
        class="form-group col-lg-4"
        [hidden]="extensionPeriodInterest.disabled"
      >
        <app-dc-toggle
          [labelId]="'extensionPeriodInterest'"
          [label]="labels.creditProvision.extensionPeriodInterest"
          formControlName="extensionPeriodInterest"
        ></app-dc-toggle>
      </div>
      <div
        *ngIf="
          form.get(
            'kidWithdrawalRightsDisclosure'
          ) as kidWithdrawalRightsDisclosure
        "
        class="form-group col-lg-4"
        [hidden]="kidWithdrawalRightsDisclosure.disabled"
      >
        <app-dc-toggle
          [labelId]="'kidWithdrawalRightsDisclosure'"
          [label]="labels.creditProvision.kidWithdrawalRightsDisclosure"
          formControlName="kidWithdrawalRightsDisclosure"
        ></app-dc-toggle>
      </div>
    </div>

    <div class="form-row">
      <div
        *ngIf="
          form.get(
            'maturityCapitalProtectedSecurities'
          ) as maturityCapitalProtectedSecurities
        "
        class="form-group col-lg-4"
        [hidden]="maturityCapitalProtectedSecurities.disabled"
      >
        <app-dc-toggle
          [labelId]="'maturityCapitalProtectedSecurities'"
          [label]="labels.creditProvision.maturityCapitalProtectedSecurities"
          formControlName="maturityCapitalProtectedSecurities"
        ></app-dc-toggle>
      </div>
      <div
        *ngIf="
          form.get(
            'underlyingLinkedRedemptionSecurities'
          ) as underlyingLinkedRedemptionSecurities
        "
        class="form-group col-lg-4"
        [hidden]="underlyingLinkedRedemptionSecurities.disabled"
      >
        <app-dc-toggle
          [labelId]="'underlyingLinkedRedemptionSecurities'"
          [label]="labels.creditProvision.underlyingLinkedRedemptionSecurities"
          formControlName="underlyingLinkedRedemptionSecurities"
        ></app-dc-toggle>
      </div>
      <div
        *ngIf="form.get('unwindCosts') as unwindCosts"
        class="form-group col-lg-4"
        [hidden]="unwindCosts.disabled"
      >
        <app-dc-toggle
          [labelId]="'unwindCosts'"
          [label]="labels.creditProvision.unwindCosts"
          formControlName="unwindCosts"
        ></app-dc-toggle>
      </div>
    </div>
  </div>

  <div class="form-group" [hidden]="form?.disabled">
    <h3>{{ labels.creditProvision.excludedObligations }}</h3>
    <div class="form-row">
      <div
        *ngIf="form.get('excludedObligations') as excludedObligations"
        class="form-group col-lg-2"
        [hidden]="excludedObligations.disabled"
      >
        <app-dc-select
          [labelId]="'excludedObligations'"
          [label]="labels.creditProvision.excludedObligations"
          [items]="applicableItems"
          closeOnSelect="true"
          formControlName="excludedObligations"
          [clearSelection]="true"
        ></app-dc-select>
      </div>
      <div
        *ngIf="form.get('excludedObligationsList') as excludedObligationsList"
        class="form-group col-lg-6"
        [hidden]="excludedObligationsList.disabled"
      >
        <app-dc-select
          [labelId]="'excludedObligationsList'"
          [label]="labels.creditProvision.excludedObligationsList"
          [items]="referenceObligationItemsFiltered"
          closeOnSelect="true"
          formControlName="excludedObligationsList"
          [clearSelection]="true"
          multiple="true"
          checkbox="true"
          [readonly]="excludedObligationsList.readOnly"
        ></app-dc-select>
      </div>
    </div>
  </div>

  <div class="form-group">
    <h3>{{ labels.creditProvision.settlementProvisions }}</h3>
    <div class="settlementArea">
      <app-dc-loading *ngIf="isLoadingPhysicalMatrixData"></app-dc-loading>
      <!-- PSM Dependent area -->
      <div class="form-row">
        <div
          *ngIf="
            form.get('physicalSettlementMatrix') as physicalSettlementMatrix
          "
          class="form-group col-lg-2"
          [hidden]="physicalSettlementMatrix.disabled"
        >
          <app-dc-select
            [labelId]="'physicalSettlementMatrix'"
            [label]="labels.creditProvision.physicalSettlementMatrix"
            [items]="applicableItems"
            closeOnSelect="true"
            formControlName="physicalSettlementMatrix"
          ></app-dc-select>
        </div>
        <div
          *ngIf="form.get('creditEvents') as creditEvents"
          class="form-group col-lg-4"
          [hidden]="creditEvents.disabled"
        >
          <app-dc-select
            [labelId]="'creditEvents'"
            [label]="labels.creditProvision.creditEvents"
            [items]="creditEventsItems"
            closeOnSelect="true"
            formControlName="creditEvents"
            [clearSelection]="true"
            [multiple]="true"
            [checkbox]="true"
            [readonly]="creditEvents.readOnly"
          ></app-dc-select>
        </div>
        <div
          *ngIf="form.get('creditEventGracePeriod') as creditEventGracePeriod"
          class="form-group col-lg-4"
        >
          <app-dc-input
            [label]="labels.creditProvision.creditEventGracePeriod"
            [id]="'creditEventGracePeriod'"
            type="text"
            [pattern]="'[0-9]{1,3}[dmyDMY]{1}'"
            [helpText]="
              'Format is NNNT wher NNN is a number and T is a type:<br><br>D = numbers 1 to 365 only<br>M = numbers 1 to 12 only<br>Y = numbers 1 to 99 only. '
            "
            formControlName="creditEventGracePeriod"
            customErrorMessage="Please use correct formatting e.g. 11D, 5M or 2Y"
            [readonly]="creditEventGracePeriod.readOnly"
          ></app-dc-input>
        </div>
      </div>

      <div class="form-row">
        <div
          *ngIf="form.get('settlementMethod') as settlementMethod"
          class="form-group col-lg-2"
          [hidden]="settlementMethod.disabled"
        >
          <app-dc-select
            [labelId]="'settlementMethod'"
            [label]="labels.creditProvision.settlementMethod"
            [items]="settlementItems"
            closeOnSelect="true"
            formControlName="settlementMethod"
            [clearSelection]="true"
            [readonly]="settlementMethod.readOnly"
          ></app-dc-select>
        </div>
        <div
          *ngIf="form.get('fixedRecoveryAmount') as fixedRecoveryAmount"
          class="form-group col-lg-2"
          [hidden]="fixedRecoveryAmount.disabled"
        >
          <app-dc-input-number-percent-indicative-final
            [label]="labels.creditProvision.fixedRecoveryAmount"
            [id]="'fixedRecoveryAmount'"
            formControlName="fixedRecoveryAmount"
            defaultUnit="pct"
            [readonly]="fixedRecoveryAmount.readOnly"
            [allowNegativeNumbers]="false"
          ></app-dc-input-number-percent-indicative-final>
        </div>
        <div
          *ngIf="
            form.get('fallbackSettlementMethod') as fallbackSettlementMethod
          "
          class="form-group col-lg-2"
          [hidden]="fallbackSettlementMethod.disabled"
        >
          <app-dc-select
            [labelId]="'fallbackSettlementMethod'"
            [label]="labels.creditProvision.fallbackSettlementMethod"
            [items]="fallbackSettlementItems"
            closeOnSelect="true"
            formControlName="fallbackSettlementMethod"
            [clearSelection]="true"
            [readonly]="fallbackSettlementMethod.readOnly"
          ></app-dc-select>
        </div>
      </div>

      <div class="form-row">
        <div
          *ngIf="form.get('allGuarantees') as allGuarantees"
          class="form-group col-lg-4"
          [hidden]="allGuarantees.disabled"
        >
          <app-dc-toggle
            [labelId]="'allGuarantees'"
            [label]="labels.creditProvision.allGuarantees"
            formControlName="allGuarantees"
          ></app-dc-toggle>
        </div>
        <div
          *ngIf="form.get('escrow') as escrow"
          class="form-group col-lg-4"
          [hidden]="escrow.disabled"
        >
          <app-dc-toggle
            labelId="escrow"
            [label]="labels.creditProvision.escrow"
            formControlName="escrow"
          ></app-dc-toggle>
        </div>
        <div
          *ngIf="
            form.get(
              'noticeOfPubliclyAvailableInformation'
            ) as noticeOfPubliclyAvailableInformation
          "
          class="form-group col-lg-4"
          [hidden]="noticeOfPubliclyAvailableInformation.disabled"
        >
          <app-dc-toggle
            [label]="
              labels.creditProvision.noticeOfPubliclyAvailableInformation
            "
            labelId="noticeOfPubliclyAvailableInformation"
            formControlName="noticeOfPubliclyAvailableInformation"
          ></app-dc-toggle>
        </div>
      </div>

      <!-- NEW DYNAMIC SECTION GOING IN HERE -->
      <ng-container *ngIf="referenceEntitiesIds?.size">
        <hr />
        <ng-container
          *ngFor="
            let group of settlementProvisions.controls;
            let last = last;
            let i = index
          "
        >
          <app-settlement-method
            [entity]="
              referenceEntitiesIds.get(group.get('referenceEntityId').value)
            "
            [form]="group"
            [labels]="labels"
            [currencies]="currencyItems"
            [index]="i"
          >
          </app-settlement-method>
          <hr *ngIf="!last" />
        </ng-container>
      </ng-container>
      <!-- END OF DYNAMIC SECTION -->

      <div class="form-group" [hidden]="form?.disabled">
        <h3>{{ labels.creditProvision.supplements }}</h3>
        <div class="form-row">
          <div
            *ngIf="form.get('ntceSupplement') as ntceSupplement"
            class="form-group col-lg-4"
            [hidden]="ntceSupplement.disabled"
          >
            <app-dc-toggle
              [label]="labels.creditProvision.ntceSupplement"
              formControlName="ntceSupplement"
              labelId="ntceSupplement"
            ></app-dc-toggle>
          </div>
          <div
            class="form-group col-lg-4"
            [hidden]="form.get('provisionsMonolineInsurer')?.disabled"
          >
            <app-dc-toggle
              [labelId]="'provisionsMonolineInsurer'"
              [label]="labels.creditProvision.provisionsMonolineInsurer"
              formControlName="provisionsMonolineInsurer"
            ></app-dc-toggle>
          </div>
          <div
            class="form-group col-lg-4"
            [hidden]="form.get('supplementTo2014ISDACDD')?.disabled"
          >
            <app-dc-toggle
              [labelId]="'supplementTo2014ISDACDD'"
              [label]="labels.creditProvision.supplementTo2014ISDACDD"
              formControlName="supplementTo2014ISDACDD"
            ></app-dc-toggle>
          </div>
        </div>

        <div class="form-row">
          <div
            class="form-group col-lg-4"
            [hidden]="form.get('suppUSMunicipals')?.disabled"
          >
            <app-dc-toggle
              [labelId]="'suppUSMunicipals'"
              [label]="labels.creditProvision.suppUSMunicipals"
              formControlName="suppUSMunicipals"
            ></app-dc-toggle>
          </div>
          <div
            class="form-group col-lg-4"
            [hidden]="form.get('supp2014SovereignNoAssetPkgDelivery')?.disabled"
          >
            <app-dc-toggle
              [labelId]="'supp2014SovereignNoAssetPkgDelivery'"
              [label]="
                labels.creditProvision.supp2014SovereignNoAssetPkgDelivery
              "
              formControlName="supp2014SovereignNoAssetPkgDelivery"
            ></app-dc-toggle>
          </div>
        </div>
      </div>

      <div class="form-group" [hidden]="form?.disabled">
        <h3>{{ labels.creditProvision.additionalProvisions }}</h3>
        <div class="form-row">
          <div
            class="form-group col-lg-4"
            [hidden]="form.get('provisionsForArgentineRepublic')?.disabled"
          >
            <app-dc-toggle
              [labelId]="'provisionsForArgentineRepublic'"
              [label]="labels.creditProvision.provisionsForArgentineRepublic"
              formControlName="provisionsForArgentineRepublic"
            ></app-dc-toggle>
          </div>
          <div
            class="form-group col-lg-4"
            [hidden]="
              form.get('addnProvisionsCertainRussianEntities')?.disabled
            "
          >
            <app-dc-toggle
              [labelId]="'addnProvisionsCertainRussianEntities'"
              [label]="
                labels.creditProvision.addnProvisionsCertainRussianEntities
              "
              formControlName="addnProvisionsCertainRussianEntities"
            ></app-dc-toggle>
          </div>
          <div
            class="form-group col-lg-4"
            [hidden]="
              form.get('addnProvisionsCertainVenezuelanEntities')?.disabled
            "
          >
            <app-dc-toggle
              [labelId]="'addnProvisionsCertainVenezuelanEntities'"
              [label]="
                labels.creditProvision.addnProvisionsCertainVenezuelanEntities
              "
              formControlName="addnProvisionsCertainVenezuelanEntities"
            ></app-dc-toggle>
          </div>
        </div>

        <div class="form-row">
          <div
            *ngIf="
              form.get(
                'financialReferenceEntityTerms'
              ) as financialReferenceEntityTerms
            "
            class="form-group col-lg-4"
            [hidden]="financialReferenceEntityTerms.disabled"
          >
            <app-dc-toggle
              [labelId]="'financialReferenceEntityTerms'"
              [label]="labels.creditProvision.financialReferenceEntityTerms"
              formControlName="financialReferenceEntityTerms"
            ></app-dc-toggle>
          </div>
          <div
            class="form-group col-lg-4"
            [hidden]="form.get('addnProvisionsHellenicRepublic')?.disabled"
          >
            <app-dc-toggle
              [labelId]="'addnProvisionsHellenicRepublic'"
              [label]="labels.creditProvision.addnProvisionsHellenicRepublic"
              formControlName="addnProvisionsHellenicRepublic"
            ></app-dc-toggle>
          </div>
          <div
            class="form-group col-lg-4"
            [hidden]="form.get('provisionsForLPN')?.disabled"
          >
            <app-dc-toggle
              [labelId]="'provisionsForLPN'"
              [label]="labels.creditProvision.provisionsForLPN"
              formControlName="provisionsForLPN"
            ></app-dc-toggle>
          </div>
        </div>

        <div class="form-row">
          <div
            class="form-group col-lg-4"
            [hidden]="form.get('provisionsForRepublicOfHungary')?.disabled"
          >
            <app-dc-toggle
              [labelId]="'provisionsForRepublicOfHungary'"
              [label]="labels.creditProvision.provisionsForRepublicOfHungary"
              formControlName="provisionsForRepublicOfHungary"
            ></app-dc-toggle>
          </div>
          <div
            class="form-group col-lg-4"
            [hidden]="form.get('provisionsForRussianFederation')?.disabled"
          >
            <app-dc-toggle
              [labelId]="'provisionsForRussianFederation'"
              [label]="labels.creditProvision.provisionsForRussianFederation"
              formControlName="provisionsForRussianFederation"
            ></app-dc-toggle>
          </div>
          <div
            class="form-group col-lg-4"
            [hidden]="form.get('seniorNonPreferredRefObligations')?.disabled"
          >
            <app-dc-toggle
              [labelId]="'seniorNonPreferredRefObligations'"
              [label]="labels.creditProvision.seniorNonPreferredRefObligations"
              formControlName="seniorNonPreferredRefObligations"
            ></app-dc-toggle>
          </div>
        </div>

        <div class="form-row">
          <div
            *ngIf="
              form.get(
                'subordinatedEuropeanInsuranceTerms'
              ) as subordinatedEuropeanInsuranceTerms
            "
            class="form-group col-lg-4"
            [hidden]="subordinatedEuropeanInsuranceTerms.disabled"
          >
            <app-dc-toggle
              [labelId]="'subordinatedEuropeanInsuranceTerms'"
              [label]="
                labels.creditProvision.subordinatedEuropeanInsuranceTerms
              "
              formControlName="subordinatedEuropeanInsuranceTerms"
            ></app-dc-toggle>
          </div>
          <div
            class="form-group col-lg-4"
            [hidden]="form.get('provisionsForSukukCorporate')?.disabled"
          >
            <app-dc-toggle
              [labelId]="'provisionsForSukukCorporate'"
              [label]="labels.creditProvision.provisionsForSukukCorporate"
              formControlName="provisionsForSukukCorporate"
            ></app-dc-toggle>
          </div>
        </div>
      </div>
    </div>
    <!-- END OF PSM AREA-->
  </div>

  <div class="form-group" [hidden]="form?.disabled">
    <h3>{{ labels.creditProvision.otherTermsSpecialConditions }}</h3>
    <div class="form-row">
      <div
        class="form-group col-lg-12"
        [hidden]="form.get('otherTermsOrConditions')?.disabled"
      >
        <app-dc-textarea
          [label]="labels.creditProvision.otherTermsOrConditions"
          [id]="'otherTermsOrConditions'"
          type="text"
          formControlName="otherTermsOrConditions"
        ></app-dc-textarea>
      </div>
    </div>
  </div>
</ng-container>
